import { Button, SelectChangeEvent } from '@mui/material';
import { Select } from '@zeptonow/zui';
import Typography from '@zeptonow/zui/Typography';
import { useState } from 'react';
import { UserStore } from '../../store';
import { closeModal } from '../../utilities/utils';

const EntitySelectionModal = (data?: { isSelectionRequired?: boolean }) => {
  const isSelectionRequired = data?.isSelectionRequired;

  const entityCodes = UserStore((state) => state.entityCodesList);
  const setEntityCode = UserStore((state) => state.setEntityCode);
  const entityCode = UserStore((state) => state.entityCode);
  const [entity, setEntity] = useState<string>(entityCode || '');

  const handleEntityCodeChange = (e: SelectChangeEvent<unknown>) => {
    const {
      target: { value },
    } = e;

    setEntity(value as string);
  };

  const confirmEntitySelection = () => {
    const reload = entity !== entityCode && !isSelectionRequired;

    setEntityCode(entity);
    closeModal();

    if (reload) window.location.reload();
  };

  return (
    <div className="w-full p-3">
      <Typography className="!font-bold !text-2xl !mb-4">
        Please select entity!
      </Typography>
      <div className="mb-7">
        <Typography className="!mb-2">
          You have multiple entities linked to this account. Please choose one
          to continue.
        </Typography>
        {entityCodes && (
          <Select
            value={entity}
            options={entityCodes.map((code) => ({
              id: code,
              label: code,
            }))}
            placeholder="Select Entity"
            onChange={handleEntityCodeChange}
          />
        )}
      </div>
      <div className="flex gap-2">
        {!isSelectionRequired && (
          <Button className="w-full" variant="outlined" onClick={closeModal}>
            Cancel
          </Button>
        )}
        <Button
          disabled={!entity}
          variant="contained"
          className="w-full"
          onClick={confirmEntitySelection}
        >
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default EntitySelectionModal;
